'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('./item/index.js');

var _index2 = _interopRequireDefault(_index);

var _group = require('./group/index.js');

var _group2 = _interopRequireDefault(_group);

var _index3 = require('./navigation/index.js');

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index4['default'];


_index4['default'].Group = _group2['default'];
_index4['default'].Item = _index2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-navigation/lib/index.js
// module id = 419
// module chunks = 0